import React, { useRef, useEffect, useMemo } from 'react';
import { Box } from '@material-ui/core';
import { useSelector } from 'dva';
import * as echarts from 'echarts';

export default ({ height }) => {
  const {
    data,
    xData = [],
    filterType,
  } = useSelector((state) => state.behaviorData);
  const barRef = useRef(null);
  const isCustom = useMemo(() => {
    return filterType === 'CUSTOM_RATIO';
  }, [filterType]);

  useEffect(() => {
    if (height === 0) {
      return false;
    }
    const myChart = echarts.init(barRef?.current);
    let option;

    option = {
      tooltip: {
        trigger: 'item',
        textStyle: {
          fontSize: 12,
          lineHeight: 30,
          fontWeight: 'bold',
        },
        formatter: (params) => {
          const { dataIndex, value } = params || {};
          const item = data[dataIndex];
          return `<div>
            <div style="height:30px">${item?.behaveDate}</div>
            <div style="height:30px;display:flex;justify-content: space-between;"><span>总用户量</span><span>${
              isCustom ? value : item?.number
            }人</span></div>
            <div style="height:30px;width:150px;display:flex;justify-content: space-between;"><span>行为事件数量</span><span>${
              isCustom ? item?.number : value
            }个</span></div>
          </div>`;
        },
        borderWidth: 0,
      },
      yAxis: {
        type: isCustom ? 'value' : 'category',
        data: xData,
      },
      xAxis: {
        type: isCustom ? 'category' : 'value',
        data: xData,
      },
      grid: {
        left: 50,
      },
      series: [
        {
          data: data,
          type: 'bar',
          label: {
            show: true,
            position: 'right',
            formatter: '{c}%',
            color: '#ffffff',
          },
          barWidth: 30,
        },
      ],
    };

    option && myChart.setOption(option);
    myChart.resize();
    window.addEventListener(
      'resize',
      function () {
        myChart.resize();
      },
      false,
    );
    return () => {
      window.removeEventListener('resize', function () {
        myChart.resize();
      });
    };
  }, [xData, data, height, filterType, isCustom]);

  return <Box ref={barRef} sx={{ width: '100%', height: height + 'px' }}></Box>;
};
